import React, { createContext } from 'react';
import { twMerge } from 'tailwind-merge';

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

/** True under a `Card`, so a table inside one drops its own frame (DESIGN.md §1.5). */
export const InCardContext = createContext(false);

export const Card: React.FC<CardProps> = ({ children, className = '' }) => {
  return (
    <div
      className={twMerge(
        'rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900',
        className,
      )}
    >
      <InCardContext.Provider value={true}>{children}</InCardContext.Provider>
    </div>
  );
};
